import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "helpText", "warning"]
  static values = { maxItems: Number }

  connect() {
    this.boundValidateSelection = () => this.validateSelection()
    this.validateSelection()
    this.addEventListeners()
  }

  disconnect() {
    if (this.boundValidateSelection) {
      this.fieldTarget.removeEventListener('change', this.boundValidateSelection)
    }
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  addEventListeners() {
    this.fieldTarget.addEventListener('change', this.boundValidateSelection)

    // Also listen for mutation events in case the multiselect updates the field programmatically
    this.observer = new MutationObserver(this.boundValidateSelection)
    this.observer.observe(this.fieldTarget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['selected']
    })
  }

  validateSelection() {
    const selectedCount = this.getSelectedCount()
    const maxItems = this.maxItemsValue || 3
    
    this.updateHelpText(selectedCount, maxItems)
    this.updateWarningVisibility(selectedCount > maxItems)
  }

  getSelectedCount() {
    if (!this.fieldTarget.selectedOptions) return 0
    return this.fieldTarget.selectedOptions.length
  }

  updateHelpText(selectedCount, maxItems) {
    if (!this.hasHelpTextTarget) return
    
    if (selectedCount === 0) {
      this.helpTextTarget.textContent = `Select 1-${maxItems} categories that best describe your business.`
      this.helpTextTarget.className = 'mt-1 text-sm text-gray-500'
    } else if (selectedCount === maxItems) {
      this.helpTextTarget.textContent = `Maximum ${maxItems} categories selected.`
      this.helpTextTarget.className = 'mt-1 text-sm text-blue-600'
    } else if (selectedCount > maxItems) {
      this.helpTextTarget.textContent = `Too many categories selected! Maximum ${maxItems} allowed.`
      this.helpTextTarget.className = 'mt-1 text-sm text-red-600'
    } else {
      this.helpTextTarget.textContent = `${selectedCount} of ${maxItems} categories selected.`
      this.helpTextTarget.className = 'mt-1 text-sm text-gray-500'
    }
  }

  updateWarningVisibility(showWarning) {
    if (!this.hasWarningTarget) return
    
    if (showWarning) {
      this.warningTarget.style.display = 'block'
      this.warningTarget.textContent = `Please select no more than ${this.maxItemsValue || 3} categories.`
    } else {
      this.warningTarget.style.display = 'none'
    }
  }
}